import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { KeyRound, CheckCircle2 } from "lucide-react";
import portalApi from "../../lib/portalApi";

export default function PortalSetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [state, setState] = useState("checking"); // checking | ok | invalid | done
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setState("invalid"); return; }
    portalApi.get(`/set-password/validate`, { params: { token } })
      .then((r) => { if (r.data.valid) { setEmail(r.data.email || ""); setState("ok"); } else setState("invalid"); })
      .catch(() => setState("invalid"));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw.length < 6) { setErr("Mindestens 6 Zeichen"); return; }
    if (pw !== pw2) { setErr("Passwörter stimmen nicht überein"); return; }
    setBusy(true);
    try {
      await portalApi.post(`/set-password`, { token, password: pw });
      setState("done");
      setTimeout(() => nav("/portal/login"), 2200);
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Fehler");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-white rounded-3xl border border-neutral-200 shadow-sm p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="h-10 w-10 rounded-2xl bg-black text-white flex items-center justify-center"><KeyRound size={20} /></div>
          <div><div className="font-black text-lg leading-none">POPCRN Portal</div><div className="text-xs text-neutral-400">Passwort festlegen</div></div>
        </div>

        {state === "checking" && <p className="text-sm text-neutral-500">Link wird geprüft…</p>}

        {state === "invalid" && (
          <div data-testid="setpw-invalid">
            <p className="text-sm text-red-600 font-semibold mb-4">Dieser Link ist ungültig oder abgelaufen.</p>
            <button onClick={() => nav("/portal/login")} className="w-full rounded-xl bg-black text-white py-2.5 font-bold">Zur Anmeldung</button>
          </div>
        )}

        {state === "done" && (
          <div className="text-center" data-testid="setpw-done">
            <CheckCircle2 size={48} className="text-green-500 mx-auto mb-3" />
            <p className="font-semibold">Passwort gesetzt!</p>
            <p className="text-sm text-neutral-500 mt-1">Sie werden zur Anmeldung weitergeleitet…</p>
          </div>
        )}

        {state === "ok" && (
          <form onSubmit={submit} data-testid="setpw-form">
            {email && <p className="text-sm text-neutral-500 mb-4">Für <strong>{email}</strong></p>}
            <label className="block text-xs font-semibold text-neutral-500 mb-1">Neues Passwort</label>
            <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="setpw-password"
                   className="w-full rounded-xl border border-neutral-300 px-3 py-2.5 mb-3 outline-none focus:border-black" autoFocus />
            <label className="block text-xs font-semibold text-neutral-500 mb-1">Passwort wiederholen</label>
            <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="setpw-password2"
                   className="w-full rounded-xl border border-neutral-300 px-3 py-2.5 mb-4 outline-none focus:border-black" />
            {err && <p className="text-sm text-red-600 mb-3" data-testid="setpw-error">{err}</p>}
            <button type="submit" disabled={busy} data-testid="setpw-submit"
                    className="w-full rounded-xl bg-[var(--pop-pink,#e5006d)] text-white py-2.5 font-bold hover:opacity-90 disabled:opacity-50">
              {busy ? "Speichern…" : "Passwort speichern"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
